import { useSelector } from 'react-redux';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { userAuthSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { resultTypeTexts } from 'Containers/PreviousYears/utils';
import { useGetUserSatInfo } from 'Containers/PreviousYears/hooks';
import { getIsPayLater } from 'Components/Modal/components/PaymentMethodPY/utils';
import { routes } from 'Constants/routes';
import * as Styled from '../../styles';
import { ResultBoxToReturnProps } from '../ResultBox/types';
import YearData from '../YearData';

const ResultBoxToReturn = ({ data }: ResultBoxToReturnProps): JSX.Element => {
  const { data: efirma, isLoading } = useGetUserSatInfo();
  const user = useSelector(userAuthSelector);
  const { t } = useTranslation(locizeNS.PY);

  const handleClickToReturn = (priceAmount: number): void => {
    if (efirma?.efirmaIsValid && getIsPayLater(priceAmount)) {
      history.push(routes.PREVIOUS_YEARS_PROVIDER_ACCOUNT);
    } else if (getIsPayLater(priceAmount)) {
      history.push(routes.PREVIOUS_YEARS_FILTER, {
        amount: data?.amountPending,
      });
    } else {
      history.push(routes.PREVIOUS_YEARS_CHECKOUT);
    }
  };

  const refundStatus = data?.refundStatusType?.toUpperCase();
  const resultTypeCopys = resultTypeTexts[refundStatus];
  const name = user?.personalInfo?.name ? user.personalInfo.name.split(' ')[0] : '';
  const formattedName = name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : '';

  return (
    <Styled.Box direction="column" align="center" gap="dimension_16">
      <FlexContainer direction="column" align="center" gap="dimension_08">
        <Text align="center" type="headline" size="XS_L_S" color="dark">
          {t(resultTypeCopys?.title, { name: formattedName })}
        </Text>
        <Text type="paragraphs" size="M_XL_S" color="dark">
          {t(resultTypeCopys?.subtitle)}
        </Text>
        <Text type="headline" color="fresh" size="M_L_S">
          {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.amountPending ?? 0))}
        </Text>
      </FlexContainer>
      <FlexContainer direction="column" align="center" gap="dimension_16" fullWidth>
        <Text type="paragraphs" size="XS_L_S" color="grey">
          {t('Previous.years.result.info')}
        </Text>
        <YearData data={data} handleClick={handleClickToReturn} />
        <Buttons.Classic
          mode="primary"
          size="m"
          label={t(resultTypeCopys?.buttonLabel)}
          disabled={isLoading}
          onClick={() => handleClickToReturn(data?.amountPending)}
        />
      </FlexContainer>
    </Styled.Box>
  );
};

export default ResultBoxToReturn;
